import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-2 max-w-150 text-sm-but-a-bit-smaller" };
const _hoisted_2 = { class: "font-bold" };
const _hoisted_3 = { class: "flex justify-between gap-24 pb-4 border-b-2" };
const _hoisted_4 = { class: "flex flex-col items-end gap-1 text-right" };
const _hoisted_5 = { class: "font-bold" };
const _hoisted_6 = { class: "flex flex-col text-xs text-gray-500 dark:text-primary-200" };
const _hoisted_7 = {
    key: 0,
    class: "mt-4"
};
const _hoisted_8 = { class: "whitespace-nowrap" };
const _hoisted_9 = { class: "pl-7" };
const _hoisted_10 = { class: "w-full pl-7" };
const _hoisted_11 = { class: "flex items-center justify-end" };
const _hoisted_12 = { class: "whitespace-nowrap" };
const _hoisted_13 = { class: "pl-7" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.workspaces.seats_modifier'),
    compatConfig: {
        COMPONENT_V_MODEL: false
    }
};
import { computed } from 'vue';
import moment from 'moment';
import { PLAN_PRICES } from '@/constants';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'SeatsModifier',
    props: {
        modelValue: null,
        workspace: null,
        fixedSeatsDisplayed: { default: 'current' },
        updateTotalSeats: { type: Boolean, default: true }
    },
    emits: ['update:modelValue'],
    setup(__props, { emit }) {
        const props = __props;
        const currentSeats = computed(() => (props.workspace.seats ? props.workspace.seats : 0));
        const seatsAvailable = computed(() => {
            const { workspace } = props;
            const membersCount = workspace.members.length;
            const invitedEmailsCount = new Set(workspace.invitations.map((i) => i.email)).size;
            const seatsTaken = membersCount + invitedEmailsCount;
            return currentSeats.value - seatsTaken;
        });
        const fixedSeats = computed(() => props.fixedSeatsDisplayed === 'current' ? currentSeats.value : seatsAvailable.value);
        const totalSeats = computed(() => props.updateTotalSeats ? currentSeats.value + props.modelValue : currentSeats.value);
        const workspacePlan = computed(() => props.workspace.plan);
        const paymentPeriod = computed(() => props.workspace.paymentPeriod ?? 'annual');
        const initialContractDate = moment(props.workspace.subscriptionPeriodStart).format('MMM D, YYYY');
        const finalContractDate = moment(props.workspace.subscriptionPeriodEnd).format('MMM D, YYYY');
        const months = 12;
        const estimatedCharge = computed(() => {
            if (workspacePlan.value === 'pro') {
                return paymentPeriod.value === 'annual'
                    ? PLAN_PRICES.PRO.ANNUAL * months * props.modelValue
                    : PLAN_PRICES.PRO.MONTHLY * props.modelValue;
            }
            else {
                return paymentPeriod.value === 'annual'
                    ? PLAN_PRICES.PREMIUM.ANNUAL * months * props.modelValue
                    : PLAN_PRICES.PREMIUM.MONTHLY * props.modelValue;
            }
        });
        function handleModelValueUpdate(value) {
            emit('update:modelValue', value);
        }
        return (_ctx, _cache) => {
            const _component_NumberField = _resolveComponent("NumberField");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('add_seats')), 1),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_NumberField, {
                        class: "flex w-14 min-w-14 text-align-last-center",
                        integer: "",
                        min: 0,
                        max: 999,
                        "model-value": __props.modelValue,
                        "onUpdate:modelValue": handleModelValueUpdate
                    }, null, 8, ["model-value"]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(__props.modelValue > 1
                            ? _ctx.$t('charge', {
                                charge: _unref(estimatedCharge),
                                period: _ctx.$t(_unref(paymentPeriod))
                            })
                            : _ctx.$t('single_seat_charge', {
                                charge: _unref(estimatedCharge),
                                period: _ctx.$t(_unref(paymentPeriod))
                            })), 1),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('term')) + _toDisplayString(_unref(initialContractDate)) + " - " + _toDisplayString(_unref(finalContractDate)), 1),
                        (_ctx.$slots.primary)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _renderSlot(_ctx.$slots, "primary")
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("table", null, [
                    _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_8, _toDisplayString(__props.fixedSeatsDisplayed === 'current' ? _ctx.$t('current_seats') : _ctx.$t('available_seats')), 1),
                            _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(fixedSeats)), 1),
                            _createElementVNode("td", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _renderSlot(_ctx.$slots, "fixed-seats-action")
                                ])
                            ])
                        ]),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$t('total_seats')), 1),
                            _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(totalSeats)), 1)
                        ])
                    ])
                ])
            ]));
        };
    }
});
